/* eslint-disable no-multi-assign */
let counter = 0;

class Organisation {
  constructor(data) {
    if (!data || !data.name) {
      return null;
    }
    this.id = data.id || `${(counter += 1)}-${new Date().getTime()}`;
    this.isPublic = data.isPublic;
    this.name = data.name || "not available";
    this.localLang = data.localLang || "";
    this.abbreviation = data.abbreviation || "";
    this.countryCode = data.countryCode || "";
    this.uri = data.uri || "";
    this.country = data.country;
  }
}

export default Organisation;
